<discussion *ngIf="newDiscussion"
            [discussion]="newDiscussion"
            [isAddNew]="true"
            [currentUser]="currentUser"
            (event)="onEvent($event)"></discussion>

<div class="discussion-list" *ngIf="currentUser">
    <discussion
    [discussion]="discussion"
    [currentUser]="currentUser"
    [users]="users"
    (event)="onEvent($event)"
    *ngFor="let discussion of discussions"></discussion>
</div>

<div class="paginition">
    <mat-paginator [length]="pageInfo.total" [pageSize]="pageInfo.pageSize" [pageSizeOptions]="pageInfo.options"
        (page)="onPageChanged($event)">
    </mat-paginator>
</div>
